import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ViewerItemInterface, ViewerOptionInterface, ViewerOptionInterfaceInput, instaneOfViewerOptionInput } from '../../core';

import styles from './MenuChoiceOptionsInput.module.scss';

export interface MenuChoiceOptionsInputProps {
  isOpen: boolean;
  options: ViewerOptionInterface[];
  bulkDataOptions: ViewerOptionInterface[] | undefined;
  setBulkDataOptionValue: (option: ViewerOptionInterfaceInput, value: string) => void;
  showOptionPreview: (option: ViewerOptionInterface) => void;
  onSelectOptions: (item: ViewerItemInterface) => void;
  optionSelect: (option: ViewerOptionInterface) => void;
}

const MenuChoiceOptionsInput: React.FC<MenuChoiceOptionsInputProps> = (props) => {
  const [t] = useTranslation();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>, option: ViewerOptionInterfaceInput) => {
    props.setBulkDataOptionValue(option, e.target.value);
  };

  const getOptionBulkDataValue = (option: ViewerOptionInterfaceInput) => {
    const bulkDataOption = props.bulkDataOptions?.find((opt) => opt.id === option.id) as ViewerOptionInterfaceInput;
    return bulkDataOption?.value;
  };
  return (
    <div className={styles.ff_menu_choice_options__container}>
      <div
        className={classnames(styles.ff_menu_choice_options, {
          [styles.ff_menu_choice_options__open]: props.isOpen,
        })}
        data-testid='ff-menu-choice-options'
      >
        {props.options.map((opt) => {
          if (instaneOfViewerOptionInput(opt)) {
            return (
              <div key={`${t(opt.id)}-${opt.name}`} className={classnames(styles.ff_menu_choice_option)}>
                <div className={styles.ff_menu_choice_option_description}>{t(opt.id)}</div>
                <input
                  value={getOptionBulkDataValue(opt)}
                  type='number'
                  min={0}
                  max={100}
                  className={styles.ff_menu_choice_option_input}
                  onChange={(e) => onChange(e, opt)}
                />
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default MenuChoiceOptionsInput;
